import {forwardRef, useEffect, useCallback, useState} from 'react'
import {DatePicker} from '@mui/x-date-pickers'
import TextField from '@mui/material/TextField'



const DatePickerField = forwardRef(({
  field: { name, value, onBlur },
  form:  { touched, errors, setFieldValue, isSubmitting },
  helperText,
  minDate,
  maxDate,
  disabled,
  disablePast = true,
  inputFormat = 'MMMM do, yyyy',
  textFieldProps = {},
  ...pickerProps
}, ref) => {

  const errorMsg = errors[name]
  const isError  = touched[name] && Boolean(errorMsg)

  const [open, setOpen] = useState(false)

  useEffect(() => {
    if (value == null || +value < +minDate) {
      setFieldValue(name, minDate)
    }
  }, [minDate, value, name, setFieldValue])


  const handleChange = useCallback(
    date => setFieldValue(name, date),
    [name, setFieldValue]
  )


  function openCalendar(e) {
    if (disabled) return
    setOpen(true)
  }

  function closeCalendar(e) {
    setOpen(false)
  }


  return (
    <DatePicker
      open={open}
      onOpen={openCalendar}
      onClose={closeCalendar}
      value={value}
      onChange={handleChange}
      onBlur={onBlur}
      disablePast={disablePast}
      inputFormat={inputFormat}
      disabled={disabled}
      readOnly={disabled}
      minDate={minDate instanceof Date ? minDate : new Date(minDate)}
      maxDate={maxDate instanceof Date ? maxDate : new Date(maxDate)}
      {...pickerProps}
      slots={{textField: TextField}}
      slotProps={{
        textField: {
          inputRef: ref,
          error: isError,
          helperText: isError ? errorMsg : helperText,
          disabled: isSubmitting,
          variant: 'filled',
          onClick: openCalendar,
          inputProps: {
            ...textFieldProps.inputProps,
            style: { cursor: 'pointer' }
          },
          ...textFieldProps,
        }
      }}
    />
  )
})

export default DatePickerField


